import React, { useState } from "react";

const CancelOrder = () => {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");

  return (
    <div className="cancel-page" style={{marginTop:"115px"}}>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb">
        Home &gt; My Orders &gt; OD4363693… &gt; <span>Cancel</span>
      </div> */}

      <div className="cancel-wrapper">
        {/* LEFT SECTION */}
        <div className="cancel-left">
          {/* STEP 1 */}
          <div className="cancel-card">
            <div className="step-header active">
              <span className="step-number">1</span>
              <h4>EASY CANCELLATION</h4>
            </div>

            <div className="form-body">
              <div className="form-row">
                <label>
                  Reason for Cancellation <span>*</span>
                </label>

                <div className="select-box">
                  <select
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  >
                    <option value="">Select Reason</option>
                    <option>Item not required anymore</option>
                    <option>Found cheaper elsewhere</option>
                    <option>Ordered by mistake</option>
                    <option>Delivery taking too long</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <label>
                  Comments <span>*</span>
                </label>
                <textarea
                  placeholder="eg: Item not required anymore."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>

              <div className="form-actions">
                <button className="continue-btn">CONTINUE</button>
              </div>
            </div>
          </div>

          {/* STEP 2 */}
          <div className="cancel-card muted">
            <div className="step-header">
              <span className="step-number">2</span>
              <h4>REFUND MODES</h4>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="cancel-right">
          <div className="item-card">
            <h5>ITEM DETAILS</h5>

            <div className="item-info">
              <div>
                <p className="item-title">
                  SINGHTECH AW950 RGB GAMING MOUSE Wired Ambidextrous Optical
                  Gaming Mouse
                </p>
                <p className="qty">Qty: 1</p>
                <h4>₹216</h4>
              </div>

              <img
                src="https://rukminim2.flixcart.com/image/312/312/xif0q/mouse/h/x/z/aw950-singhtech-original-imaghhgzfd8rmjxe.jpeg"
                alt="product"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelOrder;